import React, { FC } from 'react';
import { Typography, Space, Button, Spin, Row, Col, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';
import cx from 'classnames';

import { Form, CountryInput, BackButton } from '~/components';
import { useCurrentBusinessKyc, useKycPage } from '~/hooks/kyc';
import { useStatefulForm } from '~/hooks/form';
import { formWidth } from './utils';
import { NamePath } from 'antd/lib/form/interface';

const CompanyAddress: FC<any> = (props) => {
  const { className } = props;
  const [t] = useTranslation('kyc');
  const [tt] = useTranslation('translation');

  const { currentBusiness, setCurrentBusiness, isLoading } = useCurrentBusinessKyc();
  const { form, handleFormChange } = useStatefulForm<typeof currentBusiness>(currentBusiness);

  const kycPage = useKycPage();
  const onFinish = (values: any) => {
    const newBusiness = { ...currentBusiness, ...values };
    if (!isEqual(newBusiness, currentBusiness)) {
      setCurrentBusiness(newBusiness);
    }
    kycPage.goNext();
  };

  const getNamePath = (name: NamePath) => ['address', name].flat();

  return (
    <Space direction="vertical" size="large" className={cx(className, 'Step-Container')}>
      <div>
        <Typography.Title level={3}>{t('Company address')}</Typography.Title>
      </div>
      {isLoading ? (
        <Spin />
      ) : (
        <Form
          form={form}
          onValuesChange={(_, newValues) => handleFormChange(newValues)}
          onFinish={onFinish}
          layout="vertical"
        >
          <Row gutter={[rowGap, 0]}>
            <Col flex="none" style={{ width: formWidth.width + rowGap }}>
              <Form.Item
                label={tt('country')}
                name={getNamePath('country')}
                rules={[{ required: true }]}
              >
                <CountryInput disabled />
              </Form.Item>
              <Form.Item label={tt('postalCode')} name={getNamePath('postalCode')}>
                <Input />
              </Form.Item>
              <Form.Item
                label={tt('region')}
                name={getNamePath('region')}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item label={tt('city')} name={getNamePath('city')} rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item
                label={tt('address')}
                name={getNamePath('addressLine')}
                rules={[{ required: true }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col>
              <BackButton onClick={kycPage.goBack} size="large" />
            </Col>
            <Col>
              <Form.Item noStyle>
                <Button type="primary" htmlType="submit" size="large">
                  {t('translation:Next')}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </Space>
  );
};

const rowGap = 16;

export default CompanyAddress;
